enum CostMode {
  ContributingEpics = 'contributing_epics',
  ContributingTeams = 'contributing_teams',
}

type ChartDataItem = {
  id: string;
  title: string;
  name?: string;
  size: number;
  percentage: number;
  fill?: string;
};

export { CostMode };
export type { ChartDataItem };
